import type { ListEncountersParams } from "@elation/api-client/src/stitch-web";
import { useListEncounters } from "@elation/api-client/src/stitch-web";

export const RECENT_VISITS_LIMIT = 10;

export function useRecentVisitsQuery(limit = RECENT_VISITS_LIMIT) {
  const params: ListEncountersParams = {
    limit,
    sortBy: "startedAt",
    order: "desc",
  };

  return useListEncounters(params);
}
